import PatientClinicalView from "./PatientClinicalView";

export default PatientClinicalView